import React from 'react';
import {NumberInput} from "@chakra-ui/react";
import {Field} from "@/components";

export const NumberInputView = ({ label, required, onChange, conditional, precision, step, min, max,...props }) => {

    return (
        <Field
            label={`${label}${required ? '*' : ''} :`}
            {...props}
        >
            <NumberInput.Root
                {...(max ? {max} : {})}
                {...(min ? {min} : {})}
                precision={precision ?? 0}
                step={step ?? 1}
                onChange={e => onChange?.(parseFloat(e))}
                placeholder={label}
                {...((max || min) ? {clampValueOnBlur: true, defaultValue: min || max} : {})}
            >
                <NumberInput.Input />
                <NumberInput.Control>
                    <NumberInput.IncrementTrigger />
                    <NumberInput.DecrementTrigger />
                </NumberInput.Control>
            </NumberInput.Root>
        </Field>
    );
};

export default NumberInputView;
